/* ════════════════════════════════════════════════════════════════
   Predictive search overlay
   Ported from the claude.ai/design "Predictive Search" export.
   Live results come from sections/sk-predictive-results.liquid via
   Shopify's /search/suggest?section_id= endpoint. Quick-add reuses the
   real AJAX cart + sk-cart drawer (sk-cart.js event: sk-cart:added).
   ════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var root = document.querySelector(".sk-predictive");
  if (!root) return;

  var panel    = root.querySelector("#psPanel");
  var veil     = root.querySelector("#psVeil");
  var input    = root.querySelector("#psInput");
  var clearBtn = root.querySelector("#psClear");
  var body     = root.querySelector("#psBody");
  var results  = root.querySelector("#psResults");
  var emptyQ   = root.querySelector("#psEmptyQ");
  var statusEl = root.querySelector("#psStatus");

  var sectionId = root.getAttribute("data-results-section") || "sk-predictive-results";
  var triggers  = document.querySelectorAll("[data-sk-search-open]");
  var closers   = root.querySelectorAll("[data-sk-search-close]");

  var debounceTimer = null;
  var controller = null;
  var activeIndex = -1;
  var lastQuery = "";

  /* ── open / close ─────────────────────────── */
  function open() {
    if (root.classList.contains("is-open")) return;
    root.classList.add("is-open");
    document.body.classList.add("ps-lock");
    input.setAttribute("aria-expanded", "true");
    triggers.forEach(function (t) { t.setAttribute("aria-expanded", "true"); });
    setMode("idle");
    // focus after the panel is painted (mobile keyboards behave better)
    requestAnimationFrame(function () { input.focus(); });
  }
  function close() {
    if (!root.classList.contains("is-open")) return;
    root.classList.remove("is-open");
    document.body.classList.remove("ps-lock");
    input.setAttribute("aria-expanded", "false");
    triggers.forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
    if (controller) { controller.abort(); controller = null; }
  }

  /* ── state machine ────────────────────────── */
  function setMode(mode) {
    panel.setAttribute("data-mode", mode);
    activeIndex = -1;
    clearActive();
  }

  /* ── fetch + render ───────────────────────── */
  function run(q) {
    q = (q || "").trim();
    toggleClear();
    if (!q) { lastQuery = ""; setMode("idle"); return; }
    if (q === lastQuery && panel.getAttribute("data-mode") === "results") return;
    lastQuery = q;

    setMode("loading");
    if (controller) controller.abort();
    controller = new AbortController();

    var url = "/search/suggest?q=" + encodeURIComponent(q) +
      "&section_id=" + encodeURIComponent(sectionId) +
      "&resources[type]=product,collection,page" +
      "&resources[limit]=8&resources[limit_scope]=each";

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // only paint if this is still the latest query
        if (q !== lastQuery) return;
        results.innerHTML = html;
        var inner = results.querySelector(".ps-results-inner");
        var count = inner ? parseInt(inner.getAttribute("data-ps-count"), 10) || 0 : 0;
        if (count > 0) {
          highlight(q);
          setMode("results");
          announce(count + " result" + (count === 1 ? "" : "s") + " for " + q);
        } else {
          if (emptyQ) emptyQ.textContent = q;
          setMode("empty");
          announce("No results for " + q);
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        // network hiccup → fall back to the full search page link behaviour
        if (emptyQ) emptyQ.textContent = q;
        setMode("empty");
      });
  }

  /* ── highlight the matched term in titles/subtitles ── */
  function highlight(q) {
    var rx;
    try { rx = new RegExp("(" + q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig"); }
    catch (e) { return; }
    results.querySelectorAll(".ps-title, .ps-sub").forEach(function (el) {
      var text = el.textContent;
      if (!rx.test(text)) return;
      el.innerHTML = "";
      var last = 0, m;
      rx.lastIndex = 0;
      while ((m = rx.exec(text)) !== null) {
        if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)));
        var mark = document.createElement("mark");
        mark.textContent = m[0];
        el.appendChild(mark);
        last = m.index + m[0].length;
        if (m.index === rx.lastIndex) rx.lastIndex++; // guard zero-width
      }
      if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
    });
  }

  function announce(msg) { if (statusEl) statusEl.textContent = msg; }

  function toggleClear() {
    if (!clearBtn) return;
    if (input.value) clearBtn.removeAttribute("hidden");
    else clearBtn.setAttribute("hidden", "");
  }

  /* ── keyboard navigation over visible rows ── */
  function navItems() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('.ps-state[data-state="' + panel.getAttribute("data-mode") + '"] .ps-row, .ps-state[data-state="results"] .ps-all'),
      function (el) { return el.offsetParent !== null; }
    );
  }
  function clearActive() {
    panel.querySelectorAll(".is-active").forEach(function (el) { el.classList.remove("is-active"); });
  }
  function move(dir) {
    var items = navItems();
    if (!items.length) return;
    clearActive();
    activeIndex += dir;
    if (activeIndex < 0) activeIndex = items.length - 1;
    if (activeIndex >= items.length) activeIndex = 0;
    var el = items[activeIndex];
    el.classList.add("is-active");
    el.scrollIntoView({ block: "nearest" });
  }
  function activate() {
    var items = navItems();
    var el = items[activeIndex];
    if (!el) return false;
    var href = el.getAttribute("href") || el.getAttribute("data-href") || (el.querySelector(".ps-hit") && el.querySelector(".ps-hit").getAttribute("href"));
    if (href) { window.location.href = href; return true; }
    return false;
  }

  /* ── quick-add (single-variant rows only) ── */
  function quickAdd(btn) {
    var id = btn.getAttribute("data-variant-id");
    if (!id || btn.disabled) return;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.classList.add("added");
        btn.textContent = "✓ Added";
        document.dispatchEvent(new CustomEvent("sk-cart:added", { detail: { open: true } }));
        close();
        setTimeout(function () {
          btn.classList.remove("added");
          btn.textContent = "+ Add";
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () { btn.disabled = false; });
  }

  /* ── events ───────────────────────────────── */
  triggers.forEach(function (t) {
    t.setAttribute("aria-haspopup", "dialog");
    t.setAttribute("aria-expanded", "false");
    t.addEventListener("click", function (e) { e.preventDefault(); open(); });
  });
  closers.forEach(function (c) { c.addEventListener("click", close); });

  input.addEventListener("input", function () {
    toggleClear();
    clearTimeout(debounceTimer);
    var q = input.value;
    debounceTimer = setTimeout(function () { run(q); }, 200);
  });

  if (clearBtn) clearBtn.addEventListener("click", function () {
    input.value = ""; lastQuery = ""; toggleClear(); setMode("idle"); input.focus();
  });

  // chips (idle + empty) → seed the query
  root.addEventListener("click", function (e) {
    var chip = e.target.closest(".ps-chip");
    if (chip) { input.value = chip.getAttribute("data-q") || chip.textContent.trim(); input.focus(); run(input.value); return; }
    var add = e.target.closest(".ps-add");
    if (add) { e.preventDefault(); quickAdd(add); return; }
    // click anywhere else on a product row (e.g. the price) → open the PDP
    var row = e.target.closest(".ps-row[data-href]");
    if (row && !e.target.closest("a")) { window.location.href = row.getAttribute("data-href"); }
  });

  // keyboard within the panel
  panel.addEventListener("keydown", function (e) {
    if (e.key === "ArrowDown") { e.preventDefault(); move(1); }
    else if (e.key === "ArrowUp") { e.preventDefault(); move(-1); }
    else if (e.key === "Enter") { if (activate()) e.preventDefault(); }
    else if (e.key === "Escape") { e.preventDefault(); close(); }
  });

  // global: Esc closes, "/" opens (when not already typing in a field)
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) { close(); return; }
    if (e.key === "/" && !root.classList.contains("is-open")) {
      var t = e.target, tag = t && t.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || (t && t.isContentEditable)) return;
      e.preventDefault(); open();
    }
  });

  // simple focus trap: keep Tab inside the open panel
  panel.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var f = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
